import compareVersions from 'compare-versions';

export function sortVersions(versions) {
  return Object.keys(versions).sort(compareVersions).reverse();
}

export function getLastVersion(versions) {
  return sortVersions(versions)[0];
}
